module.exports = __webpack_public_path__ + "static/img/7.e507a3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/7.png
// module id = zQV/
// module chunks = 0